import { CreateCommandService } from './create-command';
import { CreateWizardCommandService } from './create-wizard-command';
import { InviteCommandService } from './invite-command';
import { LogCommandService } from './log-command';
import { StatusCommandService } from './status-command';

export const SERVICES = [
  InviteCommandService,
  CreateCommandService,
  CreateWizardCommandService,
  StatusCommandService,
  LogCommandService,
];
